import { DEFAULT_COMPANY_TIME_ZONE, formatPlanTokens, formatTry, type CheckoutStatusDto } from '@dbrain/shared';
import { Button, Dialog, Icons } from '@dbrain/ui';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { settingsLink } from '../settings/links.js';

/**
 * Phase 16c (B2cOdemeTamam): "Pro'ya hoş geldiniz" over the home page once the checkout's payment is taken: the
 * amount, what is open now, the next payment. It comes with the navigation's state, so a reload does not show it again.
 */
export function ProWelcome() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const status = (location.state as { proWelcome?: CheckoutStatusDto } | null)?.proWelcome;
  const subscription = status?.subscription;
  if (!status || !subscription) return null;
  const close = () => void navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  const locale = i18n.language;
  const terms = subscription.terms;
  const next = new Date(subscription.currentPeriodEnd).toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: DEFAULT_COMPANY_TIME_ZONE });
  const open = [
    t('b2cBilling.welcome.tokens', { tokens: formatPlanTokens(terms.dailyTokens, locale) }),
    t('b2cBilling.welcome.documents', { documents: terms.maxDocuments.toLocaleString(locale) }),
    t('b2cBilling.welcome.files', { mb: terms.maxFileMb }),
    ...(terms.ownConnections ? [t('b2cBilling.welcome.connections')] : []),
  ];
  return (
    <Dialog title={t('b2cBilling.welcome.title')} onClose={close} closeLabel={t('common.close')} size="sm" className="pro-welcome" data-testid="pro-welcome">
      <div className="pro-welcome__body">
        <span className="pro-welcome__check" aria-hidden="true">
          <Icons.check size={26} />
        </span>
        <p className="pro-welcome__paid">{t('b2cBilling.welcome.paid', { amount: formatTry(status.amountKurus, locale) })}</p>
        <div className="pro-welcome__open">
          <p className="pro-welcome__open-title">{t('b2cBilling.welcome.open')}</p>
          <ul>
            {open.map((line) => (
              <li key={line}>
                <Icons.check size={14} aria-hidden="true" />
                {line}
              </li>
            ))}
          </ul>
        </div>
        <p className="pro-welcome__next">{t('b2cBilling.welcome.next', { date: next, amount: formatTry(subscription.nextChargeKurus, locale) })}</p>
        <div className="pro-welcome__actions">
          <Button
            variant="secondary"
            onClick={() => void navigate(settingsLink('subscription', { ...location, state: null }).to, { replace: true, state: settingsLink('subscription', { ...location, state: null }).state })}
            data-testid="pro-welcome-details"
          >
            {t('b2cBilling.welcome.details')}
          </Button>
          <Button onClick={close} data-testid="pro-welcome-start">
            {t('b2cBilling.welcome.start')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
